<script lang="ts">
  let currentYear: number = new Date().getFullYear();

</script>

<footer
  class="retailer-footer background-grayDark color-white padding-top--small padding-bottom--small"
>
  <div class="grid-container">
    <div class="grid-row">
      <div class="grid-col c12-12 notranslate">
        © {currentYear}
        {window["C"].COMPANY_NAME}, Inc. |
        <a
          href="/privacy"
          target="_blank"
          rel="noopener noreferrer"
          class="underline-hover color-white">Privacy Policy</a
        >
        |
        <a
          href="/terms"
          target="_blank"
          rel="noopener noreferrer"
          class="underline-hover color-white">Terms & Conditions</a
        >
        |
        <a
          href="/terms/ads"
          target="_blank"
          rel="noopener noreferrer"
          class="underline-hover color-white">Provi Ad Terms and Conditions</a
        >
        |
        <a
          href="https://www.provi.com/privacy/opt-out"
          rel="noopener noreferrer"
          target="_blank"
          class="underline-hover color-white">Do Not Sell My Information</a
        >
      </div>
    </div>
  </div>
</footer>
